import request from '@/config/axios'

/** 预售活动商品 */
export interface PresaleProductVO {
  id?: number
  activityId?: number
  spuId: number
  skuId: number
  /** 1全款 2定金 */
  presaleMode: number
  shipTime: string
  depositType?: number
  depositValue?: number
  finalPayType?: number
  finalPayStart?: string
  finalPayEnd?: string
  finalPayStartDays?: number
  finalPayEndDays?: number
  stock: number
  totalStock?: number
}

export interface PresaleActivityVO {
  id?: number
  shopId?: number
  name: string
  status?: number
  remark?: string
  startTime: string
  endTime: string
  totalLimitCount?: number
  singleLimitCount?: number
  productCount?: number
  createTime?: string
  products?: PresaleProductVO[]
}

export const getPresaleActivityPage = async (params: any) => {
  return await request.get({ url: '/promotion/presale-activity/page', params })
}

export const getPresaleActivity = async (id: number) => {
  return await request.get({ url: '/promotion/presale-activity/get?id=' + id })
}

// —— 以下接口 P1 实现，P0 先占位路径 ——
export const createPresaleActivity = async (data: PresaleActivityVO) => {
  return await request.post({ url: '/promotion/presale-activity/create', data })
}

export const updatePresaleActivity = async (data: PresaleActivityVO) => {
  return await request.put({ url: '/promotion/presale-activity/update', data })
}

export const closePresaleActivity = async (id: number) => {
  return await request.put({ url: '/promotion/presale-activity/close?id=' + id })
}

export const deletePresaleActivity = async (id: number) => {
  return await request.delete({ url: '/promotion/presale-activity/delete?id=' + id })
}
